import { createApi } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '../base/baseQuery'

export const questionServiceApi = createApi({
  reducerPath: 'questionServiceApi',
  baseQuery: baseQuery,
  tagTypes: ['Question'],
  endpoints: (builder) => ({
    // Fetch all questions for a lesson
    getQuestionsBySubjectId: builder.query({
      query: (lessonId) => `/backoffice/lessons/${lessonId}/questions`,
      providesTags: (result, error, lessonId) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: 'Question', id })),
              { type: 'Question', id: 'LIST' },
            ]
          : [{ type: 'Question', id: 'LIST' }],
    }),
    // Fetch all questions for a rule
    getQuestionsByRuleId: builder.query({
      query: (ruleId) => `/backoffice/rules/${ruleId}/questions`,
      providesTags: (result, error, ruleId) =>
        result
          ? [
              ...result?.map(({ id }) => ({ type: 'Question', id })),
              { type: 'Question', id: 'LIST' },
            ]
          : [{ type: 'Question', id: 'LIST' }],
    }),
    // Add a new question
    addQuestion: builder.mutation({
      query: (newQuestion) => ({
        url: '/backoffice/questions/save',
        method: 'POST',
        body: newQuestion,
      }),
      invalidatesTags: [{ type: 'Question', id: 'LIST' }],
    }),
    // Update a question
    updateQuestion: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/backoffice/questions/${id}`,
        method: 'PUT',
        body: formData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Question', id },
        { type: 'Question', id: 'LIST' },
      ],
    }),
    // Delete a question
    deleteQuestion: builder.mutation({
      query: (id) => ({
        url: `/backoffice/questions/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Question', id: 'LIST' }],
    }),
  }),
})

export const {
  useGetQuestionsBySubjectIdQuery,
  useGetQuestionsByRuleIdQuery,
  useAddQuestionMutation,
  useUpdateQuestionMutation,
  useDeleteQuestionMutation,
} = questionServiceApi
